import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Per-device performance view settings (text size, columns, flash), persisted in localStorage.
 * Whether notes are shown is per user (profile config: `performance.notesVisible`), not here.
 * @see https://github.com/pmndrs/zustand/blob/main/docs/integrations/persisting-store-data.md
 */

export const usePerformanceViewStore = create(
  persist<{
    fontSize: 'small' | 'medium' | 'large'
    setFontSize: (size: 'small' | 'medium' | 'large') => void
    /** Sidebar width in percentage */
    sidebarWidth: number
    setSidebarWidth: (width: number) => void
    flashBackground: boolean
    setFlashBackground: (flashBackground: boolean) => void
    columns: number
    setColumns: (columns: number) => void
    columnFill: 'auto' | 'balanced'
    setColumnFill: (columnFill: 'auto' | 'balanced') => void
    /** Show chords even when no chosen part needs them (Vocals or Drums alone). */
    showChords: boolean
    setShowChords: (showChords: boolean) => void
  }>(
    set => ({
      // Default 30 % notes / 70 % lyrics — keep lyrics primary; notes are reference
      // material that should not crowd the song body. Users can drag the splitter.
      sidebarWidth: 30,
      setSidebarWidth(width: number) {
        set({ sidebarWidth: width })
      },
      fontSize: 'medium',
      setFontSize(fontSize: 'small' | 'medium' | 'large') {
        set({ fontSize })
      },
      flashBackground: false,
      setFlashBackground(flashBackground: boolean) {
        set({ flashBackground })
      },
      columns: 1,
      setColumns(columns: number) {
        set({ columns })
      },
      columnFill: 'auto',
      setColumnFill(columnFill: 'balanced' | 'auto') {
        set({ columnFill })
      },
      showChords: false,
      setShowChords(showChords: boolean) {
        set({ showChords })
      },
    }),
    {
      name: 'tunasong.performance',
    }
  )
)
